<template>
<div>
  <h4 class="text-center">
    <i class="fas fa-file-alt mr-2" aria-hidden="true"></i>
     
  ID ORDINE - [{{orderId}}] -  <strong> {{orderData.supplier}}  - n.ro {{orderData.order_num}}  del {{orderData.order_date}} -
        {{orderData.store}} - {{orderData.season}}  {{orderData.season_year}} </strong>
     
  </h4>      

</div>
</template>
<script>


import api                 from '@/api';

export default {
   components: {},  
  props  : ['orderId'],
  data () 
  {
    return {

    orderData : {}

    }
    
    },
  computed : {
     

     },
   created () 
    {
      
        this.getOrderData()
     
    },
  methods: {
    async getOrderData()
    {
        var data  = {'orderId' :this.orderId}       
        
        var sp   = {'sp':'spOrderHeaderById'}
        var json = Object.assign(data, sp);


        await api.post(json).then(res => {
          if(res.status==200)
            {
              this.orderData = res.data.recordsets[0][0]         
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });


       


  }

  }
}
</script>

<style scoped>
 h4 {
  font-family : 'Roboto Condensed';
  font-size   : 20px;
   }
</style>
